import styled from 'styled-components';
import { StyledControlBarButton } from '../control-bar-button.styles';

export const StyledShowTOCSidebarButton = styled(StyledControlBarButton)`
  margin-bottom: 1.25em;
`;
